export default "__VITE_ASSET__CeRLT6og__"